import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import { Container, Button, Icon, Grid, Header, Checkbox } from 'semantic-ui-react'
import { Input, TextArea, Form } from 'semantic-ui-react'

import { Helmet } from "react-helmet"

import game_model from 'models/game_model'
import API_service from 'xAppLib/providers/API_service'

import { TimerProvider } from "xAppLib/Timer/TimerContext";
import Wordle from '../game/Wordle'

import UniForm from 'xAppLib/UniForm/UniForm'
import ShareLink from 'xAppLib/ShareLink/ShareLink';

import { WORDS_DICT } from "cont/words.js";

const NewGame = props => {

	const [game, setGame] = useState()
	const [gid, setGid] = useState()
	const [savedGame, setSavedGame] = useState()
	const [customGid, setCustomGid] = useState('')
	const [gidStatus, setGidStatus] = useState(null) // null | 'checking' | 'available' | 'taken' | 'invalid'
	const gidCheckTimer = React.useRef(null)


	const checkGidAvailability = (value) => {
		clearTimeout(gidCheckTimer.current)
		if (!value) {
			setGidStatus(null)
			return
		}
		if (!/^[a-zA-Z0-9_-]+$/.test(value)) {
			setGidStatus('invalid')
			return
		}
		setGidStatus('checking')
		gidCheckTimer.current = setTimeout(async () => {
			const existing = await game_model.get_game(value, 'custom')
			setGidStatus(existing ? 'taken' : 'available')
		}, 500)
	}

	return <Container>
			<Helmet>
				<title>WeWordle Game</title>
			</Helmet>

			{/*<pre>
			{JSON.stringify(app.user, null, 4)}
			</pre>*/}

			<Grid stackable>
				<Grid.Row verticalAlign="top">
					<Grid.Column mobile={16} tablet={8} computer={7}>

						<h3 style={{color: '#495057'}}>Game Settings</h3>

						<UniForm
								onActForm = {async d => {
									if (customGid && gidStatus !== 'available') {
										return
									}

									const gd = {
												game: 'wordle',
												type: 'set',
												...d
											}

									const useGid = customGid || null
									const gid = await game_model.set_game( useGid, 'custom', gd )

									setGid(gid);
									setSavedGame(gd);

									console.log('Saved game with gid', gid, gd);

									// Send game creation email (fire-and-forget — don't block the UI)
									if (app.user.user_in) {
										API_service.load_data('game/notify', {
											gid,
											name: gd.name,
											desc: gd.desc || '',
											max_guesses: gd.max_guesses || 6,
											public: gd.public !== false,
											word_length: (gd.word || '').length || 5,
											creator_name: app.user.user_det?.displayName || app.user.user_det?.email,
										}).catch(err => console.warn('game notify email failed', err));
									}
								} }

								onChange = { (d, f, vs) => setGame(vs) }

								btn_text = "Save"

								fields = { game_model.DET_FIELDS }

								onUpdate = { (vs) => setGame(vs) }
								updateOnDefaults

								>

						{
							(values, valids, uf_this) => {
								const sectionStyle = {
									background: '#f8f9fa',
									borderRadius: '8px',
									padding: '16px',
									marginBottom: '16px',
									border: '1px solid #e9ecef'
								};

								const sectionHeaderStyle = {
									color: '#495057',
									fontSize: '14px',
									fontWeight: '600',
									textTransform: 'uppercase',
									letterSpacing: '0.5px',
									marginBottom: '16px',
									paddingBottom: '8px',
									borderBottom: '1px solid #dee2e6'
								};

								const fieldLabelStyle = {
									color: '#495057',
									fontSize: '13px',
									fontWeight: '500',
									marginBottom: '6px',
									display: 'block'
								};

								const inputStyle = {
									background: '#fff',
									borderRadius: '4px'
								};

								return <Form>
									{/* Basic Info Section */}
									<div style={sectionStyle}>
										<div style={sectionHeaderStyle}>Basic Info</div>

										<Form.Field style={{marginBottom: '16px'}}>
											<label style={fieldLabelStyle}>Game Name <span style={{color: '#dc3545'}}>*</span></label>
											<Input
												name="name"
												value={values.name || ''}
												onChange={(e, {value}) => uf_this.handleInputChange({target: {name: 'name', value}})}
												placeholder="Enter a name for your game"
												fluid
												style={inputStyle}
											/>
										</Form.Field>

										<Form.Field>
											<label style={fieldLabelStyle}>Description</label>
											<TextArea
												name="desc"
												value={values.desc || ''}
												onChange={(e, {value}) => uf_this.handleInputChange({target: {name: 'desc', value}})}
												placeholder="Describe your custom game"
												rows={3}
												style={{...inputStyle, width: '100%'}}
											/>
										</Form.Field>

										<Form.Field style={{marginTop: '16px'}}>
											<label style={fieldLabelStyle}>Game ID <span style={{color: '#868e96', fontWeight: 'normal'}}>(optional)</span></label>
											<Input
												value={customGid}
												onChange={(e, {value}) => {
													const v = value.toLowerCase()
													setCustomGid(v)
													checkGidAvailability(v)
												}}
												placeholder="Auto-generated if left empty"
												fluid
												style={inputStyle}
												icon={
													gidStatus === 'checking' ? <Icon name="spinner" loading /> :
													gidStatus === 'available' ? <Icon name="check" color="green" /> :
													gidStatus === 'taken' ? <Icon name="x" color="red" /> :
													gidStatus === 'invalid' ? <Icon name="warning sign" color="orange" /> :
													null
												}
											/>
											{gidStatus === 'taken' && <span style={{color: '#dc3545', fontSize: '12px'}}>This Game ID is already taken</span>}
											{gidStatus === 'invalid' && <span style={{color: '#e67700', fontSize: '12px'}}>Only letters, numbers, hyphens, and underscores allowed</span>}
											{gidStatus === 'available' && <span style={{color: '#28a745', fontSize: '12px'}}>This Game ID is available</span>}
										</Form.Field>
									</div>

									{/* Game Rules Section */}
									<div style={sectionStyle}>
										<div style={sectionHeaderStyle}>Game Rules</div>

										{/* Word and Max Guesses - prominent display */}
										<div style={{
											display: 'flex',
											gap: '24px',
											marginBottom: '20px',
											flexWrap: 'wrap',
											background: '#fff',
											padding: '20px',
											borderRadius: '8px',
											border: '2px solid #e2e8f0',
											boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
										}}>
											<Form.Field style={{flex: '1 1 auto', minWidth: '140px'}}>
												<label style={{
													...fieldLabelStyle,
													fontSize: '16px',
													fontWeight: '600',
													color: '#2d3748',
													marginBottom: '10px'
												}}>
													The Guess Word
												</label>
												<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
													<Input
														name="word"
														value={values.word || ''}
														onChange={(e, {value}) => uf_this.handleInputChange({target: {name: 'word', value: value}})}
														placeholder="WORD"
														size="huge"
														style={{
															...inputStyle,
															width: '140px',
															fontFamily: 'monospace',
															fontSize: '24px',
															fontWeight: '600',
															letterSpacing: '10px',
															textAlign: 'center'
														}}
													/>
													<Icon
														name="sync"
														circular
														link
														style={{
															color: '#4a5568',
															fontSize: '16px',
															cursor: 'pointer'
														}}
														title="Pick random word"
														onClick={() => {
															const randomWord = WORDS_DICT[Math.floor(Math.random() * WORDS_DICT.length)];
															uf_this.handleInputChange({target: {name: 'word', value: randomWord}});
														}}
													/>
												</div>
											</Form.Field>

											<Form.Field style={{flex: '0 0 auto'}}>
												<label style={{
													...fieldLabelStyle,
													fontSize: '16px',
													fontWeight: '600',
													color: '#2d3748',
													marginBottom: '10px'
												}}>
													{/*<Icon name="redo" style={{marginRight: '6px', color: '#4a5568'}} />*/}
													Max Guesses
												</label>
												<Input
													name="max_guesses"
													type="number"
													min={1}
													max={20}
													value={values.max_guesses || 6}
													onChange={(e, {value}) => uf_this.handleInputChange({target: {name: 'max_guesses', value}})}
													size="huge"
													style={{
														...inputStyle,
														width: '80px',
														fontSize: '24px',
														fontWeight: '600',
														textAlign: 'center'
													}}
												/>
											</Form.Field>
										</div>

										{/* Check Dictionary checkbox */}
										{(() => {
											const wordLen = (values.word || '').length;
											const dictDisabled = wordLen > 0 && wordLen !== 5;
											if (dictDisabled && values.dict) {
												uf_this.handleInputChange({target: {name: 'dict', value: false}});
											}
											return (
												<Form.Field>
													<Checkbox
														name="dict"
														label="Check guesses against dictionary"
														checked={values.dict === true}
														disabled={dictDisabled}
														onChange={(_e, {checked}) => uf_this.handleInputChange({target: {name: 'dict', value: checked}})}
														style={{color: dictDisabled ? '#adb5bd' : '#495057'}}
													/>
													{dictDisabled && (
														<div style={{fontSize: '12px', color: '#868e96', marginTop: '4px', marginLeft: '24px'}}>
															Dictionary only supports 5-letter words
														</div>
													)}
												</Form.Field>
											);
										})()}
									</div>

									{/* Options Section */}
									<div style={sectionStyle}>
										<div style={sectionHeaderStyle}>Options</div>

										<Form.Field>
											<Checkbox
												name="public"
												label="Public leaderboard - allow anyone to view scores"
												checked={values.public === true}
												onChange={(e, {checked}) => uf_this.handleInputChange({target: {name: 'public', value: checked}})}
												style={{color: '#495057'}}
											/>
										</Form.Field>
									</div>

									{/* Save Button */}
									<div style={{display: 'flex', justifyContent: 'center', marginTop: '24px'}}>
										<Button
											type="button"
											color='green'
											size='large'
											disabled={!!(customGid && gidStatus !== 'available')}
											onClick={() => uf_this.actForm()}
										>
											<Icon name='save' />
											Save Game
										</Button>
									</div>
								</Form>
							}
						}

						</UniForm>

						{gid && <div>
								{/*<p>GameID: <b>{gid}</b></p>*/}
								<p>Share this link to invite others to play your custom game:</p>
								<p><Link to={`/game/${gid}`}>{window.location.origin}/game/{gid}</Link></p>
							</div>
						}

						{gid && savedGame && (
							<ShareLink
								url={`/game/${gid}`}
								title="Game Created Successfully!"
								subtitle={savedGame.name}
								shareText={`Play my custom WeWordle game: ${savedGame.name}${savedGame.desc ? ' - ' + savedGame.desc : ''}`}
								entityId={gid}
								entityType="game"
								showEntityId={true}
								// playButtonText="Play Now"
								// playButtonIcon="play"
								showPlayButton={false}
								socialPlatforms={['x', 'facebook', 'whatsapp', 'telegram', 'reddit', 'linkedin', 'email']}
								onShare={(platform, url) => {
									console.log(`Shared on ${platform}:`, url);
								}}
							/>
						)}


						{/*game?.word && gpid && 
						// <UniFormSUI
						// 	fields={game_model.DET_FIELDS}
						// 	values={game}
						// 	show='view'
						// 	// k={k}

						// 	// onSave_dets_fld = { (f, d, ca) => this.save_dets_fld(f, d, ca) }

						// 	// admin_link_to_func={ (i) => '/admin/'
						// 	// 			 + (i.t=='g' ? 'docs' : i.t=='i' ? 'doc' : 'err') + "/"
						// 	// 			 + url_base + (!url_base || url_base.endsWith('/') ? '' : '/')
						// 	// 			 + k }

						// 	// btns={<Table.Cell>
						// 	// 		<Button
						// 	// 			primary
						// 	// 			onClick={()=>this.start_edit()}
						// 	// 			content='Edit'
						// 	// 		 />
						// 	// 		<Button
						// 	// 			secondary
						// 	// 			onClick={()=>this.start_del()}
						// 	// 			content='Delete'
						// 	// 		 />
						// 	// 	</Table.Cell>}
						//  />
						*/}

					</Grid.Column>

					<Grid.Column mobile={16} tablet={8} computer={9}>

						<h3 style={{color: '#495057'}}>Preview</h3>

						{game?.word ? (
							<div style={{
								background: '#f8f9fa',
								borderRadius: '8px',
								padding: '16px',
								border: '1px solid #e9ecef'
							}}>
								<TimerProvider>
									<Wordle
										{...game}
										keyb_listn = {false}
									 />
								</TimerProvider>
							</div>
						) : (
							<div style={{
								background: '#f8f9fa',
								borderRadius: '8px',
								padding: '48px 24px',
								border: '1px solid #e9ecef',
								textAlign: 'center',
								minHeight: '300px',
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'center',
								alignItems: 'center'
							}}>
								<Icon name="gamepad" size="huge" style={{color: '#adb5bd', marginBottom: '16px'}} />
								<Header as="h4" style={{color: '#6c757d', margin: '0 0 8px 0'}}>
									Game Preview
								</Header>
								<p style={{color: '#868e96', margin: 0}}>
									Enter a word in Game Rules to see the preview
								</p>
							</div>
						)}


						<div>
							<pre>{JSON.stringify(game, null, 4)}</pre>
						</div>

					</Grid.Column>
				</Grid.Row>
			</Grid>

		</Container>
}

export default NewGame